import React, { memo } from "react";
import { Stack } from "investira.react.components";
import Concentracao from "../Concentracao";

const Limite = memo((props) => {
  const { segmentos, detalhe, variant } = props;
  return (
    <Stack spacing={4}>
      <Concentracao segmentos={segmentos} detalhe={detalhe} variant={variant} />
    </Stack>
  );
});

Limite.displayName = "Limite";

export default Limite;
